import React, { useEffect } from 'react'
import ReactModal from 'react-modal'
import startChatProgram from 'components/VirtualPortal/helpers/chatProgram'

const ErrorForm = ({ fetchingErrorMessage, tokenInputValue, handleTokenInputChange, handleTokenSubmit, token }) => {
  if(fetchingErrorMessage == 'Network Error') {
    return <p>Please try connecting to the internet and try again.</p>
  } else {
    return <form onSubmit={handleTokenSubmit}>
      <p>Provided Access Key: { token }</p>
      <input placeholder='Access Key' value={tokenInputValue} onChange={handleTokenInputChange} />
      <p><button className='btn btn-danger'>Submit</button></p>
    </form>
  }
}

const InvalidTokenScreen = ({ 
  fetchingErrorMessage, 
  tokenInputValue, 
  handleTokenInputChange, 
  handleTokenSubmit, 
  token
}) => {

  useEffect(() => {
    startChatProgram()
  },[startChatProgram])

  return(
    <div>
      <div className='virtual-portal-header'>
        <div className='container'>
          <div className='logo'>
            <img className="logoImageWide" src='/gartner_c_level_communities_white.svg' alt='loading page'/>
            <img className="logoImageStacked" src='/gartner_c_level_communities_white_stacked.png' alt='loading page'/>
          </div>
          <div className='title'>
            <div className='centered'>
            </div>
          </div>
          <div className='info'>
          </div>
        </div>
      </div>
      <div className='container center'>
        <ReactModal
          className='bad-token react-modal error-modal'
          isOpen
          appElement={document.querySelector('#root')}
          style={{ overlay: { background: 'rgba(60,59,59,0.75)' }}}>
          <div>
            <h3>Sorry, we’re having issues connecting you to your event.</h3>

            <p>Ensure you’re using Google Chrome browser for the best experience.</p>

            <p>Please enter your access key below for the event you are trying to access.</p>

            <p>For your access key or further assistance, please reach out for help using the <a className='live-chat-link' onClick={() => window.expandLiveChat()}>LiveChat</a> window.</p>

            <hr />
            <p>{ fetchingErrorMessage }</p>
            <p> 
              <ErrorForm 
                fetchingErrorMessage={fetchingErrorMessage}
                tokenInputValue={tokenInputValue}
                handleTokenInputChange={handleTokenInputChange}
                handleTokenSubmit={handleTokenSubmit} 
                token={token}
              /> 
            </p>
          </div>
        </ReactModal>
      </div>
    </div>

  )

}

export default InvalidTokenScreen